
import axios from "axios";
import { decryptionData, datetimenow } from '@/components/utils/utils.js';
import io from 'socket.io-client';

export default {
  name: 'register-public',

  data() {
    return {
      loading: true,
      success: false,
      failed: false,
      failedMessage: '',
      token: ''
    }
  },

  mounted() {
    this.getTokenFromUrl();
  },

  methods: {

    getTokenFromUrl() {
      const query = new URLSearchParams(window.location.search);
      this.token = query.get('token');

      if (!this.token) {
        this.loading = false;
        this.failed = true;
        this.failedMessage = 'Token verifikasi tidak ditemukan.';
        return;
      }

      this.verifyEmail();
    },

    async verifyEmail() {
      try {

        const response = await axios.post(
          `/auth/verify-email`,
          {
            token: this.token
          }
        );

        this.loading = false;

        if (response.data.status == 200) {
          this.success = true;
        } else {
          this.failed = true;
          this.failedMessage =
            response.data.message || 'Token sudah tidak valid.';
        }

      } catch (error) {

        this.loading = false;
        this.failed = true;

        if (error.response) {
          this.failedMessage =
            error.response.data.message ||
            'Token expired atau tidak valid.';
        } else {
          this.failedMessage =
            'Terjadi kesalahan koneksi.';
        }

      }
    }

  }
}